import { Alert } from "antd";

export default function AlertComponent({ title, message, ...props }) {
  return <Alert {...props} title={title ?? message} />;
}
